import styled from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';

type WrapperProps = {
  hasSubheader?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  max-width: 1280px;
  margin: 24px auto 0;
  position: relative;
  padding: 0 20px 65px;
  z-index: 1;
  align-items: center;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 0 32px 100px;
    margin: 24px auto 0;
    height: auto;
    min-height: auto;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
  height: 100dvh;
  position: relative;
`;

export const PageBanner = styled.img`
  width: 100%;
  margin-top: -24px;
  cursor: pointer;

  @media (min-width: ${DEVICE.laptop}) {
    width: 416px;
    display: block;
    margin: 0 auto 9px;
  }
`;

export const BottomStickyPanel = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 0;
  width: 100%;
`;
